import {Component, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {Location} from '@angular/common';
import {Router} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';

import {MatSnackBar} from '@angular/material';

import {ContentSize} from '../../modules/shared/components/page/page.component';

import {AuthService} from '../../services/auth.service';
import {LogService} from '../../services/log.service';
import {OauthService} from '../../services/oauth.service';
import {PerfService} from '../../services/perf.service';

import {DialogComponent} from '../../modules/shared/components/dialog/dialog.component';

import * as uuid from 'uuid';


@Component({
	selector: 'oauth',
	templateUrl: './oauth.component.html',
	styleUrls: ['./oauth.component.scss']
})
export class OauthComponent implements OnInit, AfterViewInit {
	constructor(
		private location: Location,
		private router: Router,
		private sanitizer: DomSanitizer,
		private snackBar: MatSnackBar,

		private authService: AuthService,
		private log: LogService,
		private oauthService: OauthService,
		private perf: PerfService
	) {}


	ContentSize = ContentSize;		// enable enum in template

	email = '';
	emailProvider = '';

	// viewHeight = '';

	// dialogTitle = '';
	// dialogContent1 = '';
	// dialogContent2 = '';
	// dialogOk = '';
	// dialogCancel = '';
	// dialogData = '';
	// helpUrlLabel = '';
	// helpUrlString = '';
	// @ViewChild('confirmDialog') confirmDialog: DialogComponent;


	ngOnInit() {
	}


	ngAfterViewInit() {
		this.perf.markTabLoadEnd('landing');
	}


	authorizedEmail() {
		console.log('authorizedEmail');

		console.log('email');
		console.log(this.email);

		console.log('emailProvider');
		console.log(this.emailProvider);

		if (!this.email) {
			this.snackBar.open('Enter email address to authorize.', 'X', {duration: 2000});
			return;
		}
		if (!this.emailProvider) {
			this.snackBar.open('Select Gmail or Outlook email provider.', 'X', {duration: 2000});
			return;
		}

		let payload: any = {
			email: this.email,
			emailProvider: this.emailProvider
		};
		this.oauthService.createEmailAuthorizationUrl(payload)
		.then((result: any) => {
			console.log('OauthComponent, result');
			console.log(result);
			this.log.info('createEmailAuthorizationUrl successful, redirecting to emailProvider. url = ' + result.authorizeUrl);

			// TODO!!! - optionally save 'state' in local storage, then check on callback

			if (result.authorizeUrl) {
				window.location.href = result.authorizeUrl;
			} else {
				this.snackBar.open('Could not create redirect URL, token already exists.', 'X', {duration: 2000});
			}
		})
		.catch((err: any) => {
			console.log(err);
			this.log.error(err);
			this.snackBar.open('Could not create redirect URL.', 'X', {duration: 2000});
		});
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/components/oauth/oauth.component.ts